import React from "react";
import "./OurServicesNew.css";

const OurServicesNew = () => {
  return (
    <>
      <div className="our-services-container">
        <div className="our-services-title-container">
          <div className="our-services-title">
            Vision, Mission and Value Statement
          </div>
        </div>
        <div className="row h-container">
          {/* <div className="col-md-3 col-lg-3 our-service-c"> */}
          <div className="ourservic-grid">
          
            <div className="ourservic-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={40}
                height={40}
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="#ff6b00"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                >
                  <circle cx={12} cy={32} r={6} fill="#ff6b00">
                    <animate
                      fill="freeze"
                      attributeName="cy"
                      dur="0.6s"
                      values="32;12"
                    ></animate>
                  </circle>
                  <g>
                    <path
                      strokeDasharray={2}
                      strokeDashoffset={2}
                      d="M12 19v1M19 12h1M12 5v-1M5 12h-1"
                    >
                      <animate
                        fill="freeze"
                        attributeName="d"
                        begin="0.7s"
                        dur="0.2s"
                        values="M12 19v1M19 12h1M12 5v-1M5 12h-1;M12 21v1M21 12h1M12 3v-1M3 12h-1"
                      ></animate>
                      <animate
                        fill="freeze"
                        attributeName="stroke-dashoffset"
                        begin="0.7s"
                        dur="0.2s"
                        values="2;0"
                      ></animate>
                    </path>
                    <path
                      strokeDasharray={2}
                      strokeDashoffset={2}
                      d="M17 17l0.5 0.5M17 7l0.5 -0.5M7 7l-0.5 -0.5M7 17l-0.5 0.5"
                    >
                      <animate
                        fill="freeze"
                        attributeName="d"
                        begin="0.9s"
                        dur="0.2s"
                        values="M17 17l0.5 0.5M17 7l0.5 -0.5M7 7l-0.5 -0.5M7 17l-0.5 0.5;M18.5 18.5l0.5 0.5M18.5 5.5l0.5 -0.5M5.5 5.5l-0.5 -0.5M5.5 18.5l-0.5 0.5"
                      ></animate>
                      <animate
                        fill="freeze"
                        attributeName="stroke-dashoffset"
                        begin="0.9s"
                        dur="0.2s"
                        values="2;0"
                      ></animate>
                    </path>
                  </g>
                </g>
              </svg>

              <div className="our-services-subtitle">Vision</div>
              <div className="our-services-text">
                To become a leading technology company recognized for designing
                smart, reliable, and accessible digital solutions that empower
                people and businesses.
              </div>
            </div>
            {/* </div> */}

            {/* <div className="col-md-3 col-lg-4 our-service-c"> */}
            <div className="ourservic-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={34}
                height={34}
                viewBox="0 0 36 36"
              >
                <circle
                  cx={18}
                  cy={18}
                  r={4.09}
                  fill="#ff6b00"
                  className="clr-i-solid clr-i-solid-path-1"
                ></circle>
                <path
                  fill="#ff6b00"
                  d="M18 7.83A10.17 10.17 0 1 0 28.17 18A10.18 10.18 0 0 0 18 7.83m0 16A5.88 5.88 0 1 1 23.88 18A5.88 5.88 0 0 1 18 23.88Z"
                  className="clr-i-solid clr-i-solid-path-2"
                ></path>
                <path
                  fill="#ff6b00"
                  d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2m0 27.83A11.83 11.83 0 1 1 29.83 18A11.85 11.85 0 0 1 18 29.83"
                  className="clr-i-solid clr-i-solid-path-3"
                ></path>
                <path fill="none" d="M0 0h36v36H0z"></path>
              </svg>

              <div className="our-services-subtitle">Mission</div>
              <div className="our-services-text">
                To develop innovative digital products that enhance
                productivity, connectivity, and convenience across key sectors
                by blending creativity, technology, and deep market insights. {" "}
              </div>
            </div>

            {/* </div> */}

            {/* <div className="col-md-4 col-lg-4 our-service-c"> */}
            <div className="ourservic-card thirdservice-card ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={40}
                height={40}
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ff6b00"
                  d="M2.952 9.702a3.25 3.25 0 0 0 0 4.597l6.75 6.75a3.25 3.25 0 0 0 4.597 0l6.75-6.75a3.25 3.25 0 0 0 0-4.597l-6.75-6.75a3.25 3.25 0 0 0-4.597 0z"
                ></path>
              </svg>

              <div className="our-services-subtitle">Value</div>
              <div className="our-services-text">
                We are driven by innovation, grounded in reliability, committed
                to user-centric design, guided by integrity, and strengthened
                through collaboration with our clients and communities.
              </div>
            </div>

            {/* </div> */}
          </div>{" "}
        </div>
      </div>
    </>
  );
};
export default OurServicesNew;
